module.exports = __webpack_public_path__ + "static/media/vizardry_screenshot.8b0d0973.webp";